/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import React from 'react';
import { defineMessages } from 'react-intl';
import { LuisTooltip } from 'src/core/components/LuisTooltip';
import { useLocalization } from 'src/core/hooks/useLocalization';
import { getStylistV2 } from 'src/core/themes/luisStylist';

const messages = defineMessages({
    isContextOnly: {
        id: 'qnaMaker.qnaMakerContextLabel.isContextOnly',
        defaultMessage: 'CONTEXT-ONLY'
    },
    description: {
        id: 'qnaMaker.qnaMakerContextLabel.description',
        defaultMessage: 'This QnA pair will not be understood out of the contextual flow.'
    }
});

const { styleDiv } = getStylistV2('QnaMakerContextLabel');

const LabelWrapper = styleDiv('LabelWrapper', {
    border: '1px solid',
    borderRadius: '10px',
    position: 'absolute',
    padding: '4px 2px',
    top: '0px',
    right: '4px',
    fontSize: '9px'
});

export const QnaMakerContextLabel = () => {
    const { localize } = useLocalization();

    return (
        <LabelWrapper>
            <LuisTooltip content={localize(messages.description)}>{localize(messages.isContextOnly)}</LuisTooltip>
        </LabelWrapper>
    );
};
